export const MINDMAP_FIT_TARGET = {
  None: 'none',
  All: 'all',
  Subtree: 'subtree',
} as const;

export type MindmapFitTarget = (typeof MINDMAP_FIT_TARGET)[keyof typeof MINDMAP_FIT_TARGET];

export interface PendingMindmapFitState {
  target: MindmapFitTarget;
  nodeIds: string[];
}
